import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.error.cause.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/imgs/ic_change.png';

const _withScopeId = n => (_pushScopeId("data-v-7df317f5"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "custom-style-warp"
};
const _hoisted_2 = {
  key: 0,
  style: {
    "width": "100%",
    "height": "100%"
  }
};
const _hoisted_3 = {
  class: "cms-card-block brand-info"
};
const _hoisted_4 = {
  class: "custom-style-list"
};
const _hoisted_5 = {
  key: 0,
  class: "nodata-warp"
};
const _hoisted_6 = {
  class: "tips"
};
const _hoisted_7 = {
  style: {
    "padding": "0 10px"
  }
};
const _hoisted_8 = {
  key: 0,
  class: "mg-t--15",
  style: {
    "font-size": "12px",
    "color": "#929BA5"
  }
};
const _hoisted_9 = {
  key: 0,
  style: {
    "width": "100%"
  }
};
const _hoisted_10 = {
  key: 1,
  style: {
    "width": "100%"
  }
};
const _hoisted_11 = {
  key: 2,
  class: "main-brand-upload",
  style: {
    "width": "100%"
  }
};
const _hoisted_12 = {
  class: "cms-module-title mg-t--40 mg-l--10"
};
const _hoisted_13 = {
  class: "base-scrollbar",
  style: {
    "padding": "0 10px",
    "max-height": "300px"
  }
};
const _hoisted_14 = {
  class: "cms-data-info-table",
  cellspacing: "0",
  cellpadding: "0"
};
const _hoisted_15 = ["width"];
const _hoisted_16 = {
  key: 0,
  class: "sub-brand-upload"
};
const _hoisted_17 = ["onClick", "src"];

const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "size"
}, "200*200", -1));

const _hoisted_19 = ["onClick"];
const _hoisted_20 = {
  style: {
    "position": "relative",
    "width": "64px",
    "height": "64px"
  }
};
const _hoisted_21 = {
  key: 0,
  style: {
    "position": "absolute",
    "right": "0",
    "top": "0"
  },
  src: _imports_0,
  alt: ""
};

const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "size"
}, "200*200", -1));

import CustomStyleGroup from './Components/customStyleGroup.vue';
import BrandLogoInfo from '../productOperations/Components/BrandLogoInfo/index.vue';
import UploadImage from '../productOperations/Components/UploadImage/index.vue';
import MyLoadingImage from '@/components/MyLoadingImage/index.vue';
import SubFormItem from './Components/subFormItem.vue';
import NoData from '@/components/NoData/index.vue';
import { getBrandList, getPlatformList } from '@/api/common';
import { useCommon } from '@/store/useCommon';
import { elMessage, getTextWidth } from '@/utils';
import { PrefixInteger } from '@/utils/cacheData';
import { clearData, getItemByProp, removePropertyOfNull, scrollIntoView } from '@/utils/tools';
import { messageBox, validatorNonNull } from '@/utils/validate';
import { onMounted, nextTick } from 'vue';
import { useI18n } from 'vue-i18n';
import { getModelListAPi, getBrandListApi, getPlatformListApi, getCustomerStyleApi, getMainBrandOptionsApi, getMainBrandUIApi, getCusMainBrandApi, getCustomerSubAgentApi, addCusMainBrandListApi, editCusMainBrandListApi, deleteCusMainBrandApi } from '@/api/vodNew';
import { ElMessage } from 'element-plus';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',

  setup(__props) {
    const {
      t
    } = useI18n();
    const storeCommon = useCommon(); // 是否为VNO账号

    const isVnoUser = computed(() => storeCommon.userData.roles.includes('VNO') || storeCommon.userData.roles.includes('VNO_CMS'));
    const formRef = ref();
    const imageItemRef = ref();
    const subFormRef = ref();
    const searchConfig = reactive({
      formList: [{
        label: '品牌',
        prop: 'brand',
        widgetType: 'Select',
        labelKey: 'prefixName',
        valueKey: 'value',
        list: [],
        clearable: false,
        filterable: true,
        change: val => {
          sessionStorage.setItem('productOperationsCid', val);
          getData();
        },
        visibleChange: visible => {
          if (!visible) {
            setTimeout(() => {
              document.querySelector('#brand-select') && document.querySelector('#brand-select').blur();
            });
          }
        },
        id: 'brand-select',
        controller: () => {
          return true;
        }
      }],
      formData: {
        brand: Number(sessionStorage.getItem('productOperationsCid'))
      }
    });
    const actionForm = reactive({
      visible: false,
      // 主品牌大图路径
      masterBigLogo: '',
      // 主品牌小图路径
      masterSmallLogo: '',
      action: '',
      loading: false,
      formList: [[{
        label: '选择主品牌',
        prop: 'mainAgentId',
        widgetType: 'Select',
        required: true,
        labelKey: 'name',
        valueKey: 'id',
        list: [],
        change: val => {
          getCustomerSubAgent();
        },
        controller: (row, data, config) => {
          config.disabled = actionForm.action == 'edit' ? true : false;
          return true;
        }
      }, {
        label: '定制主品牌名称',
        prop: 'name',
        widgetType: 'input',
        required: true
      }], [{
        label: '主品牌UI',
        prop: 'uiId',
        widgetType: 'Select',
        list: [],
        required: true,
        labelKey: 'name',
        valueKey: 'id'
      }, {
        label: '选择品牌',
        prop: 'cids',
        widgetType: 'Select',
        labelKey: 'prefixName',
        valueKey: 'id',
        list: [],
        multiple: true,
        collapseTags: true,
        'collapse-tags-tooltip': true,
        filterable: true,
        required: true,
        itemSlot: true,
        controller: () => {
          return true;
        }
      }], [{
        label: '选择平台',
        prop: 'pids',
        widgetType: 'Select',
        labelKey: 'prefixName',
        valueKey: 'id',
        list: [],
        multiple: true,
        collapseTags: true,
        'collapse-tags-tooltip': true,
        filterable: true,
        required: true,
        itemSlot: true,
        controller: () => {
          return true;
        }
      }, {
        label: '选择型号',
        prop: 'cpmIds',
        widgetType: 'selectModel',
        colspan: 3,
        searchFormData: {
          cid: [],
          pid: []
        },
        disabledBrand: storeCommon.userData.permissionKey.indexOf('OP_PO_CPMIDS') > -1,
        controller: () => {
          return true;
        }
      }], [{
        label: '上传图片',
        prop: 'uploadPicture',
        labelExtraSlot: true,
        itemSlot: true,
        required: true
      }, {
        label: '备注',
        prop: 'remark',
        widgetType: 'textarea',
        minRows: 6,
        maxRows: 6,
        maxlength: 200,
        colspan: 3,
        rules: [{
          max: 200,
          message: t('限制字符数量', {
            num: '200'
          }),
          trigger: 'blur'
        }],
        required: false
      }]],
      formData: {
        mainAgentId: '',
        uiId: '',
        name: '',
        cids: [],
        pids: [],
        cpmIds: [],
        remark: '',
        agentPicture: [// 大图标
        {
          base64Image: '',
          url: '',
          type: 1
        }, // 小图标
        {
          base64Image: '',
          url: '',
          type: 2
        }]
      },
      subFormList: [[{
        label: '子品牌名称',
        prop: 'name',
        widgetType: 'input',
        disabled: true,
        required: true
      }, {
        label: '上传图片',
        prop: 'uploadPicture',
        widgetType: 'input',
        itemSlot: true,
        required: true,
        rowspan: 2,
        style: {
          'padding': '10px 30px'
        },
        rules: [{
          required: true,
          validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error(t('请上传图片')));
            } else {
              callback();
            }
          },
          trigger: ['blur', 'change']
        }]
      }], [{
        label: '定制子品牌名称',
        prop: 'subAgentName',
        widgetType: 'input',
        required: true,
        style: {
          'border-right': '1px solid #EAEDF0'
        },
        rules: [{
          required: true,
          validator: (rule, value, callback) => validatorNonNull(rule, value, callback, '请输入定制子品牌名称'),
          trigger: 'blur'
        }, {
          min: 1,
          max: 100,
          message: t('限制字符数量', {
            num: 100
          }),
          trigger: 'blur'
        }]
      }]],
      subFormData: {
        subInfo: []
      },
      rules: {
        mainAgentId: [{
          required: true,
          validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error(t('请选择主品牌')));
            } else if (value && validateMainAgentIdText.value) {
              callback(validateMainAgentIdText.value);
            } else {
              callback();
            }
          },
          trigger: 'change'
        }],
        name: [{
          required: true,
          validator: (rule, value, callback) => validatorNonNull(rule, value, callback, actionForm.action == 'addMasterBrand' || actionForm.action == 'editMasterBrand' ? '请输入主品牌名称' : '请输入定制主品牌名称'),
          trigger: 'blur'
        }, {
          required: true,
          max: 100,
          message: t('限制字符数量', {
            num: '100'
          }),
          trigger: 'blur'
        }],
        uiId: [{
          required: true,
          message: t('请选择主品牌UI'),
          trigger: 'change'
        }],
        cids: [{
          required: true,
          message: t('请选择品牌'),
          trigger: 'change'
        }],
        pids: [{
          required: true,
          message: t('请选择平台'),
          trigger: 'change'
        }]
      },
      dialogConfig: {
        title: '定制品牌',
        destroyOnClose: true
      },
      confirm: done => {
        // console.log(actionForm.action);
        Promise.all([formRef.value.mForm.validate(), imageItemRef.value[0].validate(), subFormRef.value && subFormRef.value.validate()]).then(async valid => {
          if (valid) {
            if (actionForm.action == 'add') {
              addCustomerAgent(done);
            } else if (actionForm.action == 'edit') {
              eidtCustomerAgent(done);
            }
          }
        }).catch(err => {
          scrollIntoView();
          done();
        });
      }
    }); // 添加定制风格

    const addCustomerAgent = async done => {
      try {
        actionForm.loading = true;
        actionForm.formData.name = actionForm.formData.name.trim();
        let subInfo = JSON.parse(JSON.stringify(actionForm.subFormData.subInfo));
        let agentPicture = [];
        actionForm.formData.agentPicture.forEach(item => {
          let newItem = removePropertyOfNull(item);
          agentPicture.push(removePropertyOfNull(newItem));
        });
        let cids = brandsOptions.value.filter(item => actionForm.formData.cids.includes(item.value)).map(item => {
          return {
            id: item.value,
            name: item.label
          };
        });
        let pids = platformsOptions.value.filter(item => actionForm.formData.pids.includes(item.value)).map(item => {
          return {
            id: item.value,
            name: item.label
          };
        });
        let customerSubAgents = subInfo.map(item => {
          return {
            id: item.id,
            subAgentId: item.subAgentId,
            name: item.subAgentName,
            logoInfo: {
              type: item.type,
              base64Image: item.base64Image,
              url: item.url
            }
          };
        });
        let mids = actionForm.formData.cpmIds.map(item => {
          return {
            cid: item.cid,
            pid: item.pid,
            mid: item.mid,
            brandName: item.brandName,
            platformName: item.platformName,
            modelName: item.modelName
          };
        });
        let params = removePropertyOfNull({
          id: actionForm.formData.id,
          cid: searchConfig.formData.brand,
          name: actionForm.formData.name,
          mainAgentId: actionForm.formData.mainAgentId,
          uiId: actionForm.formData.uiId,
          remark: actionForm.formData.remark,
          cids,
          pids,
          mids,
          customerSubAgents,
          logoInfos: agentPicture
        });
        console.log('params', params);
        const res = await addCusMainBrandListApi(params);

        if (res.code == '0') {
          elMessage('success', '新增成功');
          actionForm.visible = false;
          actionForm.loading = false;
          done();
          getData();
        } else {
          actionForm.loading = false;
          done();
        }
      } catch (error) {
        actionForm.loading = false;
        done();
      }
    }; // 编辑定制风格


    const eidtCustomerAgent = async done => {
      try {
        actionForm.loading = true;
        actionForm.formData.name = actionForm.formData.name.trim();
        let subInfo = JSON.parse(JSON.stringify(actionForm.subFormData.subInfo));
        let subAgentList = subInfo.map(m => {
          delete m.uploadPicture;
          delete m.name;
          m.subAgentName = m.subAgentName.trim();
          return m;
        }).map(item => {
          item = removePropertyOfNull(item);
          return item;
        });
        let agentPicture = [];
        actionForm.formData.agentPicture.forEach(item => {
          let newItem = removePropertyOfNull(item);
          agentPicture.push(removePropertyOfNull(newItem));
        });
        let cids = brandsOptions.value.filter(item => actionForm.formData.cids.includes(item.value)).map(item => {
          return {
            id: item.value,
            name: item.label
          };
        });
        let pids = platformsOptions.value.filter(item => actionForm.formData.pids.includes(item.value)).map(item => {
          return {
            id: item.value,
            name: item.label
          };
        });
        let customerSubAgents = subInfo.map(item => {
          return {
            id: item.id,
            subAgentId: item.subAgentId,
            name: item.subAgentName,
            logoInfo: {
              type: item.type,
              base64Image: item.base64Image,
              url: item.url
            }
          };
        });
        let mids = actionForm.formData.cpmIds.map(item => {
          return {
            cid: item.cid,
            pid: item.pid,
            mid: item.mid,
            brandName: item.brandName,
            platformName: item.platformName,
            modelName: item.modelName
          };
        });
        let params = removePropertyOfNull({
          id: actionForm.formData.id,
          cid: searchConfig.formData.brand,
          name: actionForm.formData.name,
          mainAgentId: actionForm.formData.mainAgentId,
          uiId: actionForm.formData.uiId,
          remark: actionForm.formData.remark,
          cids,
          pids,
          mids,
          customerSubAgents,
          logoInfos: agentPicture
        });
        console.log('params', params);
        const res = await editCusMainBrandListApi(params);

        if (res.code == '0') {
          elMessage('success', '编辑成功');
          actionForm.visible = false;
          actionForm.loading = false;
          done();
          getData();
        } else {
          actionForm.loading = false;
          done();
        }
      } catch (error) {
        // console.log(error);
        actionForm.loading = false;
        done();
      }
    };

    const getOptionsList = async (type, cid, pid) => {
      const {
        code,
        data
      } = type === 1 ? await getBrandListApi(cid) : type === 2 ? await getPlatformListApi(cid) : await getModelListAPi(pid, cid);

      if (code == 0) {
        let resData = data.map(item => {
          return { ...item,
            prefixName: PrefixInteger(item.id, 3) + '-' + item.name,
            value: item.id,
            label: item.name
          };
        });
        return resData;
      }

      return [];
    }; // 获取弹窗品牌下拉


    const getBrandLists = async params => {
      let res = await getBrandList(params);

      if (res.code == '0') {
        let resData = res.data.map(item => ({ ...item,
          prefixName: PrefixInteger(item.cid, 3) + '-' + item.name
        }));
        return resData;
      }

      return [];
    }; // 获取弹窗平台下拉


    const getPlatformLists = async params => {
      let res = await getPlatformList(params);

      if (res.code == '0') {
        let resData = res.data.map(item => ({ ...item,
          prefixName: PrefixInteger(item.pid, 3) + '-' + item.name
        }));
        return resData;
      }

      return [];
    };

    const viewLoading = ref(false);
    const emptyLoading = ref(false);
    const platformsOptions = ref([]);
    const brandsOptions = ref([]); // 获取筛选品牌下拉选项数据

    const getBrands = async () => {
      try {
        emptyLoading.value = true;
        viewLoading.value = true;
        let ids = storeCommon.userData.cid && storeCommon.userData.cid.join(','); //const brands = await getBrandLists({ cids: ids == 0 ? '' : ids });

        const brands = await getOptionsList(1);
        let searchItem = getItemByProp(searchConfig.formList, 'brand');
        if (searchItem) searchItem.list = brands;
        brandsOptions.value = brands;
        const cid = sessionStorage.getItem('productOperationsCid');

        if (!cid && brands.length > 0) {
          sessionStorage.setItem('productOperationsCid', isVnoUser.value ? storeCommon.userData.cid[0] : brands[0].value);
          searchConfig.formData.brand = isVnoUser.value ? storeCommon.userData.cid[0] : brands[0].value;
        }

        getData();
      } catch (error) {
        viewLoading.value = false;
        emptyLoading.value = false;
      }
    }; // 弹窗品牌下拉全选


    const selectBrandAll = () => {
      if (actionForm.formData.cids.length < brandsOptions.value.length) {
        actionForm.formData.cids = [];
        brandsOptions.value.map(item => {
          actionForm.formData.cids.push(item.id);
        });
        actionForm.formData.cids.unshift(-1);
      } else {
        actionForm.formData.cids = [];
      }
    }; // 弹窗品牌下拉change事件


    const brandSelectChage = val => {
      if (!val.includes(-1) && searchConfig.formData.brand == 0 && val.length == brandsOptions.value.length) {
        actionForm.formData.cids.unshift(-1);
      } else if (val.includes(-1) && val.length - 1 < actionForm.formData.cids.length) {
        actionForm.formData.cids = actionForm.formData.cids.filter(item => {
          return item !== -1;
        });
      }
    }; // 弹窗品牌下拉移除事件


    const removeBrandTag = val => {
      if (val === -1) {
        actionForm.formData.cids = [];
      }
    }; // 弹窗平台下拉全选


    const selectPlatformsAll = () => {
      if (actionForm.formData.pids.length < platformsOptions.value.length) {
        actionForm.formData.pids = [];
        platformsOptions.value.map(item => {
          actionForm.formData.pids.push(item.id);
        });
        actionForm.formData.pids.unshift(-1);
      } else {
        actionForm.formData.pids = [];
      }
    }; // 弹窗平台下拉change事件


    const platformsSelectChage = val => {
      if (!val.includes(-1) && searchConfig.formData.brand == 0 && val.length == platformsOptions.value.length) {
        actionForm.formData.pids.unshift(-1);
      } else if (val.includes(-1) && val.length - 1 < actionForm.formData.pids.length) {
        actionForm.formData.pids = actionForm.formData.pids.filter(item => {
          return item !== -1;
        });
      }
    }; // 弹窗平台下拉移除事件


    const removePlatformsTag = val => {
      if (val === -1) {
        actionForm.formData.pids = [];
      }
    }; // 定制风格列表数据


    const customStyleLists = ref([]);

    const getData = async () => {
      try {
        !viewLoading.value ? viewLoading.value = true : '';
        const res = await getCustomerStyleApi({
          cid: searchConfig.formData.brand
        });

        if (res.code == '0') {
          customStyleLists.value = res.data ? res.data.map(item => {
            return { ...item,
              agentList: item.agentList.map(agent => {
                // 根据 subAgentList 长度动态计算 size
                const subAgentCount = agent.subAgentList ? agent.subAgentList.length : 0;
                let calculatedSize = 250; // 基础高度

                if (subAgentCount > 5) {
                  // 每增加5个项目，增加160的高度
                  const additionalGroups = Math.ceil((subAgentCount - 5) / 5);
                  calculatedSize = 250 + additionalGroups * 160;
                }

                return { ...agent,
                  uniqueId: agent.id,
                  size: calculatedSize
                };
              })
            };
          }) : [];
          viewLoading.value = false;
          emptyLoading.value = false;
        } else {
          viewLoading.value = false;
          emptyLoading.value = false;
        }
      } catch (error) {
        viewLoading.value = false;
        emptyLoading.value = false;
      }
    }; // 重置form数据表单


    const resetFromData = async () => {
      brandsOptions.value = [];
      platformsOptions.value = [];
      clearData(actionForm.formData);
      actionForm.subFormData.subInfo = [];
      validateMainAgentIdText.value = '';
      actionForm.masterBigLogo = '';
      actionForm.masterSmallLogo = '';
      actionForm.formData.agentPicture = [// 大图标
      {
        base64Image: '',
        url: '',
        type: 1
      }, // 小图标
      {
        base64Image: '',
        url: '',
        type: 2
      }];
    }; // 新建定制风格按钮点击事件


    const showAddDialog = async () => {
      const cid = searchConfig.formData.brand;
      actionForm.loading = true; // 初始化数据

      await resetFromData();
      actionForm.action = 'add';
      actionForm.dialogConfig.title = '定制品牌';
      actionForm.visible = true;

      try {
        // 并行请求通用数据和选项数据
        const [brandsData, platformsData] = await Promise.all([getOptionsListWithCache(1, Number(cid) === 0 ? undefined : cid), getOptionsListWithCache(2, Number(cid) === 0 ? undefined : cid), getRelationMainAgent(), getCustomerUiStyle()]);
        brandsOptions.value = brandsData;
        platformsOptions.value = platformsData;

        if (Number(cid) !== 0 && brandsOptions.value.length > 0) {
          actionForm.formData.cids = [brandsOptions.value[0].value];
        }

        actionForm.loading = false;
      } catch (error) {
        console.error('新建定制风格失败:', error);
        actionForm.loading = false;
      }
    }; // 编辑定制品牌按钮点击事件


    const onMaindBrandEdit = async item => {
      console.log(item);
      const {
        id
      } = item;

      try {
        await resetFromData();
        actionForm.visible = true;
        actionForm.loading = true;
        actionForm.action = 'edit';
        actionForm.dialogConfig.title = '编辑定制品牌';
        const cid = searchConfig.formData.brand; // 并行请求所有需要的数据

        const [brandsData, platformsData, mainBrandRes] = await Promise.all([getOptionsListWithCache(1, Number(cid) === 0 ? undefined : cid), getOptionsListWithCache(2, Number(cid) === 0 ? undefined : cid), getCusMainBrandApi(id), getRelationMainAgent(), getCustomerUiStyle()]);
        const res = mainBrandRes;

        if (res.code == '0') {
          if (res.data.logoInfos) {
            res.data.logoInfos.forEach(item => {
              if (item.type == 1) {
                actionForm.masterBigLogo = item.url;
              } else {
                actionForm.masterSmallLogo = item.url;
              }
            });
          }

          let {
            customerSubAgents,
            ...otherParams
          } = res.data;
          actionForm.formData = { ...otherParams,
            agentPicture: res.data.logoInfos,
            cpmIds: res.data.mids ? res.data.mids : [],
            cids: res.data.cids.map(item => item.id),
            pids: res.data.pids.map(item => item.id)
          };
          console.log('actionForm.formData', actionForm.formData);
          const {
            mainAgentId
          } = res.data;
          const subRes = await getCustomerSubAgentApi(mainAgentId);
          const diffArr = [];

          if (subRes.code == '0') {
            subRes.data.forEach(item => {
              const fItem = customerSubAgents.find(f => f.subAgentId == item.subAgentId);

              if (!fItem) {
                diffArr.push({
                  subAgentName: '',
                  name: item.subAgentName,
                  subAgentId: item.subAgentId,
                  uploadPicture: '',
                  type: 1
                });
              }
            }); // 展开图片数据

            let unfoldData = customerSubAgents.map(item => {
              return { ...item.logoInfo,
                ...item,
                name: item.subAgentName,
                subAgentName: item.name
              };
            });
            customerSubAgents = [...unfoldData, ...diffArr];
            console.log('customerSubAgentList', customerSubAgents);
          }

          ;
          actionForm.subFormData.subInfo = customerSubAgents.map(m => {
            return { ...m,
              uploadPicture: m.url || ''
            };
          });
        }

        brandsOptions.value = brandsData;
        platformsOptions.value = platformsData; // 处理全选逻辑

        if (Number(cid) == 0) {
          actionForm.formData.cids.length == brandsOptions.value.length ? actionForm.formData.cids.unshift(-1) : '';
          actionForm.formData.pids.length == platformsOptions.value.length ? actionForm.formData.pids.unshift(-1) : '';
        }

        actionForm.loading = false;
      } catch (error) {
        console.error('编辑定制品牌失败:', error);
        actionForm.loading = false;
      }
    }; // 删除定制品牌


    const onMainBrandDelete = async item => {
      messageBox(t('定制主品牌删除后，终端将不再显示定制主品牌下的所有子品牌，确定删除吗？')).then(async () => {
        actionForm.loading = true;
        const {
          code,
          data
        } = await deleteCusMainBrandApi(item.id);

        if (code == 0) {
          ElMessage({
            type: 'success',
            message: t('删除成功')
          });
          getData();
        }

        actionForm.loading = false;
      });
    }; // 回显上传图片url


    const urlStr = ref(''); // 是否显示上传图片组件

    const showUploadImage = ref(false); // 区分主品牌还是子品牌点击的上传图片 'big'主品牌大图 'small'主品牌小图 'sub'子品牌

    const uploadPictureType = ref(''); // 定制品牌主品牌上传图片点击事件

    const onMainLogoClick = type => {
      type == 'big' ? urlStr.value = actionForm.formData.agentPicture[0].url || '' : type == 'small' ? urlStr.value = actionForm.formData.agentPicture[1].url || '' : '';
      uploadPictureType.value = type;
      showUploadImage.value = true;
    }; // 当前点击的子品牌项下标


    const currentSubBrandUploadIndex = ref(null); // 子品牌上传图片点击事件

    const onSubLogoClick = index => {
      uploadPictureType.value = 'sub';
      urlStr.value = actionForm.subFormData.subInfo[index].url;
      currentSubBrandUploadIndex.value = index;
      showUploadImage.value = true;
    }; // 上传图片组件确认按钮回调函数


    const onUploadImageComfirm = (params, done) => {
      const {
        type,
        base64Image,
        url,
        file
      } = params; // 0 输入URL

      if (type == 0) {
        if (uploadPictureType.value == 'big') {
          actionForm.masterBigLogo = url;
          actionForm.formData.agentPicture[0].url = url;
          nextTick(() => {
            imageItemRef.value[0].validateField('masterBigLogo');
          });
        } else if (uploadPictureType.value == 'small') {
          actionForm.masterSmallLogo = url;
          actionForm.formData.agentPicture[1].url = url;
          nextTick(() => {
            imageItemRef.value[0].validateField('masterSmallLogo');
          });
        } else if (uploadPictureType.value == 'sub') {
          delete actionForm.subFormData.subInfo[currentSubBrandUploadIndex.value].base64Image;
          actionForm.subFormData.subInfo[currentSubBrandUploadIndex.value].url = url;
          actionForm.subFormData.subInfo[currentSubBrandUploadIndex.value].uploadPicture = url;
          nextTick(() => {
            // console.log('subFormRef', subFormRef.value, currentSubBrandUploadIndex.value);
            subFormRef.value.validateField(`subInfo[${String(currentSubBrandUploadIndex.value)}].uploadPicture`);
          });
        }
      } // 1 上传图片
      else {
        if (uploadPictureType.value == 'big') {
          actionForm.masterBigLogo = base64Image;
          actionForm.formData.agentPicture[0].url = '';
          actionForm.formData.agentPicture[0].base64Image = base64Image.split('base64,')[1];
          nextTick(() => {
            imageItemRef.value[0].validateField('masterBigLogo');
          });
        } else if (uploadPictureType.value == 'small') {
          actionForm.masterSmallLogo = base64Image;
          actionForm.formData.agentPicture[1].url = '';
          actionForm.formData.agentPicture[1].base64Image = base64Image.split('base64,')[1];
          nextTick(() => {
            imageItemRef.value[0].validateField('masterSmallLogo');
          });
        } else if (uploadPictureType.value == 'sub') {
          delete actionForm.subFormData.subInfo[currentSubBrandUploadIndex.value].url;
          actionForm.subFormData.subInfo[currentSubBrandUploadIndex.value].base64Image = base64Image.split('base64,')[1];
          actionForm.subFormData.subInfo[currentSubBrandUploadIndex.value].uploadPicture = base64Image.split('base64,')[1];
          nextTick(() => {
            // console.log('subFormRef', subFormRef.value, currentSubBrandUploadIndex.value);
            subFormRef.value.validateField(`subInfo[${String(currentSubBrandUploadIndex.value)}].uploadPicture`);
          });
        }
      }

      done();
    }; // 缓存相关变量


    const cacheData = {
      relationMainAgent: null,
      customerUiStyle: null,
      brandsOptionsCache: new Map(),
      platformsOptionsCache: new Map(),
      isInitialized: false
    }; // 预加载通用数据

    const preloadCommonData = async () => {
      if (cacheData.isInitialized) return;

      try {
        // 并行请求通用数据
        const [relationMainAgentRes, customerUiStyleRes] = await Promise.all([getMainBrandOptionsApi(), getMainBrandUIApi()]);

        if (relationMainAgentRes.code === '0') {
          cacheData.relationMainAgent = relationMainAgentRes.data;
          let item = getItemByProp(actionForm.formList, 'mainAgentId');
          if (item) item.list = relationMainAgentRes.data;
        }

        if (customerUiStyleRes.code === '0') {
          cacheData.customerUiStyle = customerUiStyleRes.data;
          let item = getItemByProp(actionForm.formList, 'uiId');
          if (item) item.list = customerUiStyleRes.data;
        }

        cacheData.isInitialized = true;
      } catch (error) {
        console.error('预加载数据失败:', error);
      }
    }; // 获取主品牌下拉（使用缓存）


    const getRelationMainAgent = async () => {
      if (cacheData.relationMainAgent) {
        let item = getItemByProp(actionForm.formList, 'mainAgentId');
        if (item) item.list = cacheData.relationMainAgent;
        return;
      }

      try {
        const res = await getMainBrandOptionsApi();

        if (res.code == '0') {
          cacheData.relationMainAgent = res.data;
          let item = getItemByProp(actionForm.formList, 'mainAgentId');
          item ? item.list = res.data : '';
        }
      } catch (error) {
        console.error('获取主品牌失败:', error);
      }
    }; // 获取UI风格下拉数据（使用缓存）


    const getCustomerUiStyle = async () => {
      if (cacheData.customerUiStyle) {
        let item = getItemByProp(actionForm.formList, 'uiId');
        if (item) item.list = cacheData.customerUiStyle;
        return;
      }

      try {
        const res = await getMainBrandUIApi();

        if (res.code == '0') {
          cacheData.customerUiStyle = res.data;
          let item = getItemByProp(actionForm.formList, 'uiId');
          item ? item.list = res.data : '';
        }
      } catch (error) {
        console.error('获取UI风格失败:', error);
      }
    }; // 获取选项列表（使用缓存）


    const getOptionsListWithCache = async (type, cid) => {
      const cacheKey = `${type}_${cid || 0}`;
      const cache = type === 1 ? cacheData.brandsOptionsCache : cacheData.platformsOptionsCache;

      if (cache.has(cacheKey)) {
        return cache.get(cacheKey);
      }

      const result = await getOptionsList(type, cid);
      cache.set(cacheKey, result);
      return result;
    }; // 校验选择主品牌显示文字


    const validateMainAgentIdText = ref(''); // 获取主品牌相关子品牌 

    const getCustomerSubAgent = async () => {
      try {
        actionForm.loading = true;
        const res = await getCustomerSubAgentApi(actionForm.formData.mainAgentId);

        if (res.code == '0') {
          actionForm.subFormData.subInfo = res.data.map(m => {
            return {
              subAgentName: '',
              name: m.subAgentName,
              subAgentId: m.subAgentId,
              uploadPicture: '',
              type: 1
            };
          });

          if (res.data.length) {
            validateMainAgentIdText.value = '';
          } else {
            validateMainAgentIdText.value = t('请先创建子品牌');
          }

          formRef.value && formRef.value.mForm.validateField('mainAgentId');
          actionForm.loading = false;
        } else {
          validateMainAgentIdText.value = t('系统错误');
          formRef.value && formRef.value.mForm.validateField('mainAgentId');
        }
      } catch (error) {
        // console.log(error);
        actionForm.loading = false;
        validateMainAgentIdText.value = t('系统错误');
        formRef.value && formRef.value.mForm.validateField('mainAgentId');
      }
    }; //  内容超出时显示提示


    const tipDisabled = ref(false);

    const showTextTip = e => {
      const target = e.target;
      const width = getTextWidth(target.innerText);
      tipDisabled.value = target.offsetWidth > width;
    }; // 清除缓存数据


    const clearCache = () => {
      cacheData.relationMainAgent = null;
      cacheData.customerUiStyle = null;
      cacheData.brandsOptionsCache.clear();
      cacheData.platformsOptionsCache.clear();
      cacheData.isInitialized = false;
    };

    onMounted(() => {
      getBrands(); // 预加载通用数据

      preloadCommonData();
    });
    watch(() => [actionForm.formData.cids, actionForm.formData.pids], val => {
      let item = getItemByProp(actionForm.formList, 'cpmIds');
      item.searchFormData.cid = val[0] && val[0].filter(item => item != -1);
      item.searchFormData.pid = val[1] && val[1].filter(item => item != -1);
    }, {
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_SearchForm = _resolveComponent("SearchForm");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_tooltip = _resolveComponent("el-tooltip");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_form = _resolveComponent("el-form");

      const _component_FormItem = _resolveComponent("FormItem");

      const _component_FormTable = _resolveComponent("FormTable");

      const _component_m_dialog = _resolveComponent("m-dialog");

      const _directive_loading = _resolveDirective("loading");

      const _directive_permission = _resolveDirective("permission");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [emptyLoading.value ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, null, 512)), [[_directive_loading, emptyLoading.value]]) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_SearchForm, {
        isCardBlock: false,
        "form-list": searchConfig.formList,
        "form-data": searchConfig.formData,
        "is-show-btns": false
      }, null, 8, ["form-list", "form-data"]), _createVNode(_component_el_button, {
        onClick: showAddDialog,
        class: "cms-op-btn cms-op-btn-main"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('添加定制')), 1)]),
        _: 1
      })]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customStyleLists.value, (item, index) => {
        return _openBlock(), _createBlock(CustomStyleGroup, {
          key: index,
          groupItem: item,
          onOnEdit: onMaindBrandEdit,
          onOnDelete: onMainBrandDelete
        }, null, 8, ["groupItem"]);
      }), 128)), !customStyleLists.value.length && !viewLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(NoData, null, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('您还没有定制风格，点击 “创建” 按钮创建。')), 1), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          onClick: showAddDialog,
          class: "cms-op-btn cms-op-btn-main"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('创建')), 1)]),
          _: 1
        })), [[_directive_permission, 'OP_PO_MC']])]),
        _: 1
      })])) : _createCommentVNode("", true)])), [[_directive_loading, viewLoading.value]])], 64)), _createVNode(_component_m_dialog, {
        autoLoading: "",
        modelValue: actionForm.visible,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => actionForm.visible = $event),
        "dialog-config": actionForm.dialogConfig,
        nativeConfig: {
          width: '80%',
          top: '5vh',
          closeOnClickModal: false
        },
        onOnConfirm: actionForm.confirm
      }, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_FormTable, {
          style: {
            "padding": "0 10px"
          },
          ref_key: "formRef",
          ref: formRef,
          col: ['15%', '35%', '15%', '35%'],
          "form-data": actionForm.formData,
          rules: actionForm.rules
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(actionForm.formList, item => {
            return _openBlock(), _createBlock(_component_FormItem, {
              "form-item": item,
              "form-data": actionForm.formData
            }, {
              labelExtraSlot: _withCtx(scope => [scope.prop == 'uploadPicture' ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.$t('图片大小建议在500kb以内。')), 1)) : _createCommentVNode("", true)]),
              itemSlot: _withCtx(scope => [scope.prop == 'cids' ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_el_select, {
                filterable: "",
                "reserve-keyword": false,
                "fit-input-width": true,
                style: {
                  "width": "100%"
                },
                multiple: "",
                "collapse-tags": "",
                "collapse-tags-tooltip": "",
                modelValue: actionForm.formData.cids,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => actionForm.formData.cids = $event),
                onChange: brandSelectChage,
                onRemoveTag: removeBrandTag
              }, {
                default: _withCtx(() => [searchConfig.formData.brand == 0 ? (_openBlock(), _createBlock(_component_el_option, {
                  key: 0,
                  label: _ctx.$t('全部'),
                  value: -1,
                  onClick: selectBrandAll
                }, null, 8, ["label"])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(brandsOptions.value, (item, index) => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: index,
                    label: item.prefixName,
                    value: item.value
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_tooltip, {
                      disabled: tipDisabled.value,
                      effect: "light",
                      "popper-class": "self-popper",
                      content: item.prefixName,
                      placement: "top"
                    }, {
                      default: _withCtx(() => [_createElementVNode("span", {
                        style: {
                          "display": "flex"
                        },
                        onMouseover: showTextTip
                      }, _toDisplayString(item.prefixName), 33)]),
                      _: 2
                    }, 1032, ["disabled", "content"])]),
                    _: 2
                  }, 1032, ["label", "value"]);
                }), 128))]),
                _: 2
              }, 1032, ["modelValue"])])) : _createCommentVNode("", true), scope.prop == 'pids' ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_component_el_select, {
                filterable: "",
                "reserve-keyword": false,
                "fit-input-width": true,
                style: {
                  "width": "100%"
                },
                multiple: "",
                "collapse-tags": "",
                "collapse-tags-tooltip": "",
                modelValue: actionForm.formData.pids,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => actionForm.formData.pids = $event),
                onChange: platformsSelectChage,
                onRemoveTag: removePlatformsTag
              }, {
                default: _withCtx(() => [searchConfig.formData.brand == 0 ? (_openBlock(), _createBlock(_component_el_option, {
                  key: 0,
                  label: _ctx.$t('全部'),
                  value: -1,
                  onClick: selectPlatformsAll
                }, null, 8, ["label"])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(platformsOptions.value, (item, index) => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: index,
                    label: item.prefixName,
                    value: item.value
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_tooltip, {
                      disabled: tipDisabled.value,
                      effect: "light",
                      "popper-class": "self-popper",
                      content: item.prefixName,
                      placement: "top"
                    }, {
                      default: _withCtx(() => [_createElementVNode("span", {
                        style: {
                          "display": "flex"
                        },
                        onMouseover: showTextTip
                      }, _toDisplayString(item.prefixName), 33)]),
                      _: 2
                    }, 1032, ["disabled", "content"])]),
                    _: 2
                  }, 1032, ["label", "value"]);
                }), 128))]),
                _: 2
              }, 1032, ["modelValue"])])) : _createCommentVNode("", true), scope.prop == 'uploadPicture' ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(_component_el_form, {
                model: actionForm,
                ref_for: true,
                ref_key: "imageItemRef",
                ref: imageItemRef
              }, {
                default: _withCtx(() => [_createVNode(BrandLogoInfo, {
                  "picture-list": actionForm.formData.agentPicture,
                  onOnLogoClick: onMainLogoClick
                }, null, 8, ["picture-list"])]),
                _: 1
              }, 8, ["model"])])) : _createCommentVNode("", true)]),
              _: 2
            }, 1032, ["form-item", "form-data"]);
          }), 256))]),
          _: 1
        }, 8, ["form-data", "rules"]), _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('子品牌')), 1), _createElementVNode("div", _hoisted_13, [actionForm.subFormData.subInfo.length ? (_openBlock(), _createBlock(_component_el_form, {
          key: 0,
          model: actionForm.subFormData,
          ref_key: "subFormRef",
          ref: subFormRef,
          class: "search-form"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(actionForm.subFormData.subInfo, (item, index) => {
            return _openBlock(), _createElementBlock("div", {
              class: "mg-b--15",
              key: index
            }, [_createElementVNode("table", _hoisted_14, [_createElementVNode("colgroup", null, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(['15%', '35%', '15%', '35%'], c => {
              return _createElementVNode("col", {
                width: c
              }, null, 8, _hoisted_15);
            }), 64))]), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(actionForm.subFormList || [], (formItem, formIndex) => {
              return _openBlock(), _createBlock(SubFormItem, {
                key: formIndex,
                "form-item": formItem,
                "form-data": actionForm.subFormData.subInfo[index],
                c_index: index,
                propName: "subInfo"
              }, {
                itemSlot: _withCtx(scope => [scope.prop == 'uploadPicture' ? (_openBlock(), _createElementBlock("div", _hoisted_16, [!item.base64Image && !item.url ? (_openBlock(), _createElementBlock(_Fragment, {
                  key: 0
                }, [_createElementVNode("img", {
                  onClick: $event => onSubLogoClick(index),
                  class: "pointer",
                  src: require('@/assets/imgs/ic_cs_sub_upload.png'),
                  alt: ""
                }, null, 8, _hoisted_17), _hoisted_18], 64)) : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  style: {
                    "display": "flex",
                    "flex-direction": "column",
                    "align-items": "center"
                  },
                  class: "pointer",
                  onClick: $event => onSubLogoClick(index)
                }, [_createElementVNode("div", _hoisted_20, [_createVNode(MyLoadingImage, {
                  style: {
                    "width": "64px",
                    "height": "64px",
                    "border-radius": "6px"
                  },
                  src: item.url ? item.url : 'data:image/png;base64,' + item.base64Image,
                  alt: ""
                }, null, 8, ["src"]), item.base64Image || item.url ? (_openBlock(), _createElementBlock("img", _hoisted_21)) : _createCommentVNode("", true)]), _hoisted_22], 8, _hoisted_19))])) : _createCommentVNode("", true)]),
                _: 2
              }, 1032, ["form-item", "form-data", "c_index"]);
            }), 128))])])]);
          }), 128))]),
          _: 1
        }, 8, ["model"])) : _createCommentVNode("", true)])])), [[_directive_loading, actionForm.loading]])]),
        _: 1
      }, 8, ["modelValue", "dialog-config", "onOnConfirm"]), _createVNode(UploadImage, {
        modelValue: showUploadImage.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => showUploadImage.value = $event),
        urlStr: urlStr.value,
        onOnComfirm: onUploadImageComfirm
      }, null, 8, ["modelValue", "urlStr"])]);
    };
  }

});